import { render } from "./driversRoutesList.vue?vue&type=template&id=198f577a&scoped=true"
import script from "./driversRoutesList.vue?vue&type=script&lang=js"
export * from "./driversRoutesList.vue?vue&type=script&lang=js"

import "./driversRoutesList.vue?vue&type=style&index=0&id=198f577a&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198f577a"]])

export default __exports__